import { render } from "./SellerList.vue?vue&type=template&id=2021da82"
import script from "./SellerList.vue?vue&type=script&lang=js"
export * from "./SellerList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__